module.exports = {"title":"Success!","description":"Your scan was successful. Press OK to continue.","ok":"OK"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/SuccessModal/locales/en.json
// module id = 1387
// module chunks = 0